import { render, staticRenderFns } from "./LogList.vue?vue&type=template&id=79cf08b0&scoped=true"
import script from "./LogList.vue?vue&type=script&lang=js"
export * from "./LogList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79cf08b0",
  null
  
)

export default component.exports